// Солнце и небо карты по московскому времени (UTC+3), одинаково круглый год, чтобы ночь не длилась 17 часов.
// Рассвет ~6:00 на востоке, полдень 13:15 на юге (62° над горизонтом), закат ~20:30 на западе;
// ночью карту освещает луна с юго-востока. Цвета — в линейном пространстве (множители к цвету земли).
// Та же формула — в scripts/mapgen-v8/sun.py (превью освещения).

export interface Daylight {
  /** Откуда светит: градусы от севера по часовой. */
  azimuth: number;
  /** Над горизонтом, градусы. */
  elevation: number;
  /** Направление на светило: (восток, север, вверх), единичный. */
  dir: [number, number, number];
  /** Цвет и сила прямого света. */
  sun: [number, number, number];
  /** Рассеянный свет неба. */
  sky: [number, number, number];
  /** 0 — ночь, 1 — день. */
  day: number;
  /** Час по Москве (дробный). */
  hour: number;
}

function smooth(a: number, b: number, x: number): number {
  const t = Math.min(1, Math.max(0, (x - a) / (b - a)));
  return t * t * (3 - 2 * t);
}

/** Час по Москве для момента времени (мс). */
export function moscowHour(nowMs: number): number {
  const msk = nowMs + 3 * 3600_000;
  return (((msk / 3600_000) % 24) + 24) % 24;
}

export function daylightAt(hour: number): Daylight {
  const rise = 6.0;
  const sets = 20.5;
  const day = (hour - rise) / (sets - rise);
  let az = 90 + 180 * Math.min(1.2, Math.max(-0.2, day));
  let el = day >= 0 && day <= 1 ? 62 * Math.sin(Math.PI * day) : -6;
  el = Math.max(el, -10);
  const dayk = smooth(-0.06, 0.08, day) * (1 - smooth(0.92, 1.06, day));
  const warm = 1 - smooth(4, 22, el);
  const sun: [number, number, number] = [
    1.25 * dayk,
    1.25 * dayk * (0.95 - 0.38 * warm),
    1.25 * dayk * (0.86 - 0.62 * warm),
  ];
  const sky: [number, number, number] = [
    0.035 + 0.3 * dayk + 0.06 * warm * dayk,
    0.045 + 0.34 * dayk,
    0.09 + 0.42 * dayk - 0.06 * warm * dayk,
  ];
  if (dayk < 0.5) {
    // Луна
    const m = 1 - dayk * 2;
    if (el < 3) {
      az = 150;
      el = 38;
    }
    sun[0] += 0.06 * m;
    sun[1] += 0.085 * m;
    sun[2] += 0.16 * m;
  }
  const a = (az * Math.PI) / 180;
  const e = (Math.max(el, 2) * Math.PI) / 180;
  return {
    azimuth: az,
    elevation: el,
    dir: [Math.sin(a) * Math.cos(e), Math.cos(a) * Math.cos(e), Math.sin(e)],
    sun,
    sky,
    day: dayk,
    hour,
  };
}
